export function OutlineOutdoorIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.94 16.5898V19.6798H9.50002C9.35002 19.4198 9.06002 19.2398 8.74002 19.2398C8.42002 19.2398 8.13002 19.4198 7.98002 19.6798H5.10002C4.95002 19.4198 4.66002 19.2398 4.34002 19.2398C4.02002 19.2398 3.73002 19.4198 3.58002 19.6798H3.02002V16.5898H10.96H10.94Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.2102 20.1202C5.2102 20.6102 4.8102 21.0002 4.3302 21.0002C3.8502 21.0002 3.4502 20.6002 3.4502 20.1202C3.4502 19.9602 3.4902 19.8102 3.5702 19.6802C3.7202 19.4202 4.0102 19.2402 4.3302 19.2402C4.6502 19.2402 4.9402 19.4202 5.0902 19.6802C5.1602 19.8102 5.2102 19.9602 5.2102 20.1202Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M9.61986 20.1202C9.61986 20.6102 9.21986 21.0002 8.73986 21.0002C8.25986 21.0002 7.85986 20.6002 7.85986 20.1202C7.85986 19.9602 7.89986 19.8102 7.97986 19.6802C8.12986 19.4202 8.41986 19.2402 8.73986 19.2402C9.05986 19.2402 9.34986 19.4202 9.49986 19.6802C9.57986 19.8102 9.61986 19.9602 9.61986 20.1202Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M5 13.0605H10.94V16.5905H3V15.0705C3 13.9605 3.9 13.0705 5 13.0705V13.0605Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.08 3H5C3.89543 3 3 3.89543 3 5V8C3 9.10457 3.89543 10 5 10H19.08C20.1846 10 21.08 9.10457 21.08 8V5C21.08 3.89543 20.1846 3 19.08 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.02 5V3"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.02002 5V3"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.02 5V3"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9399 13V20H19.5999C19.5799 19.88 19.5399 19.77 19.4899 19.67C19.3299 19.4 19.0499 19.22 18.7199 19.22C18.3899 19.22 18.0999 19.4 17.9499 19.67C17.8899 19.77 17.8499 19.88 17.8399 20H15.9399V13H20.9399Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1599 20.1107C15.1599 20.6007 14.7599 21.0007 14.2699 21.0007C13.7799 21.0007 13.3799 20.6007 13.3799 20.1107C13.3799 20.0707 13.3799 20.0307 13.3899 20.0007C13.4099 19.8807 13.4499 19.7707 13.4999 19.6707C13.6599 19.4007 13.9399 19.2207 14.2699 19.2207C14.5999 19.2207 14.8899 19.4007 15.0399 19.6707C15.0999 19.7707 15.1399 19.8807 15.1499 20.0007C15.1499 20.0307 15.1499 20.0707 15.1499 20.1107H15.1599Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6101 20.1107C19.6101 20.6007 19.2101 21.0007 18.7201 21.0007C18.2301 21.0007 17.8301 20.6007 17.8301 20.1107C17.8301 20.0707 17.8301 20.0307 17.8401 20.0007C17.8401 19.8807 17.8901 19.7707 17.9501 19.6707C18.1001 19.4007 18.3901 19.2207 18.7201 19.2207C19.0501 19.2207 19.3301 19.4007 19.4901 19.6707C19.5401 19.7707 19.5801 19.8807 19.6001 20.0007C19.6101 20.0307 19.6101 20.0707 19.6101 20.1107Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9399 13.8906V20.0006H15.1499C15.1399 19.8806 15.0999 19.7706 15.0399 19.6706C14.8899 19.4006 14.5999 19.2206 14.2699 19.2206C13.9399 19.2206 13.6599 19.4006 13.4999 19.6706C13.4499 19.7706 13.4099 19.8806 13.3899 20.0006H12.9399V15.8806C12.9399 14.7806 13.8299 13.8906 14.9299 13.8906H15.9399Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
